// Cambiar este valor cuando se corrige o reemplaza el paquete de imágenes locales.
// El parámetro evita que navegadores con una respuesta anterior en caché sigan
// mostrando imágenes rotas después de un despliegue.
const LOCAL_IMAGE_VERSION = '20260920-4';

export function versionedImageUrl(url: string | undefined | null): string {
  if (!url) return '';
  if (!url.startsWith('/') || !/\.(?:avif|gif|jpe?g|png|svg|webp)(?:[?#]|$)/i.test(url)) return url;

  const hashIndex = url.indexOf('#');
  const base = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}asset=${LOCAL_IMAGE_VERSION}${hash}`;
}

// Helper compartido para transformar URLs de Supabase Storage en thumbnails optimizados.
// resize=contain mantiene aspect ratio (no recorta).
// Si la URL no es de Supabase Storage, regresa la URL original sin modificar.
export function thumbUrl(url: string | undefined | null, width = 400, quality = 75): string {
  if (!url) return '';
  // Las imágenes locales no requieren resize, pero sí una versión para invalidar
  // respuestas rotas almacenadas por el navegador.
  if (!url.includes('/storage/v1/object/public/')) return versionedImageUrl(url);
  const u = url.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
  const sep = u.includes('?') ? '&' : '?';
  return `${u}${sep}width=${width}&height=${width}&resize=contain&quality=${quality}`;
}
